import React, { useEffect, useState, useContext } from "react";
import { DonutChart, Spinner, Link } from "@abb/abb-common-ux-react";
import "./user-loging-summary.css";
import { ERROR_LISTLogin } from "../../../strings";
import { getuserLegendsColor } from "../../../util";
import { RootContext } from "../../../contexts/root-context";
import userLoginData from './user-login-data.json'

function UserLoginSummary() {
  const {startTS, endTS, rimData, rimLaodingData, selectedSubstation ,selectedDevice } = useContext(RootContext);

  const [isSpin, setIsSpin] = useState(true); // Renamed setispin to setIsSpin
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [hoverItem, setHoverItem] = useState();

  const processUserLoginSummaryData = () => {
    if (!rimData || rimData.length === 0) {
      setData([]);
      setIsSpin(false); // Updated setispin to setIsSpin
      return;
    }

    try {
      const filteredData = rimData.filter(log => {
        const substationMatch = selectedSubstation ? log.substation === selectedSubstation : true;
        const deviceMatch = selectedDevice ? log.device_name === selectedDevice : true;
        return substationMatch && deviceMatch;
      });

      const userCounts = {
        Administrator: 0,
        Operator: 0,
        Viewer: 0,
        Engineer: 0,
        "Local HMI": 0,
      };

      const userMap = {
        [userLoginData .rawUserKeys.administrator]: userLoginData.userMapValue.Administrator,
        [userLoginData.rawUserKeys.operator]: userLoginData.userMapValue.Operator,
        [userLoginData.rawUserKeys.viewer]: userLoginData.userMapValue.Viewer,
        [userLoginData.rawUserKeys.engineer]: userLoginData.userMapValue.Engineer,
        [userLoginData.rawUserKeys.local_hmi]: userLoginData.userMapValue.Local_HMI,
      };

      filteredData.forEach(item => {
        const rawUser = item?.User?.toLowerCase()?.trim();
        const mappedUser = userMap[rawUser];
        if (mappedUser) {
          userCounts[mappedUser]++;
        }
      });

      const updatedData = Object.entries(userCounts).map(([user, count]) => ({
        key: user,
        value: count,
        label: user,
        color: getuserLegendsColor(user),
      }));

      setData(updatedData);
      setError(false);
    } catch (error) {
      console.error('Error processing login summary:', error);
      setError(true);
    } finally {
      setIsSpin(false); // Updated setispin to setIsSpin
    }
  };

  useEffect(() => {
    setIsSpin(rimLaodingData); // Updated setispin to setIsSpin
    if (!rimLaodingData) {
      processUserLoginSummaryData();
    }
  }, [startTS, endTS, rimData, rimLaodingData, selectedSubstation, selectedDevice]);

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  let contentToRender;
  if (isSpin) {
    contentToRender = (
      <Spinner style={{ margin: "auto" }} color="dark-grey" size="small" />
    );
  } else if (error) {
    contentToRender = (
      <span className="error-text">
        {ERROR_LISTLogin.ERROR_FETCH_DATA}
        <br />
        <Link style={{ color: "#1f1f1f" }} onClick={processUserLoginSummaryData}>
          Retry
        </Link>
      </span>
    );
  } else if (data?.length > 0) {
    contentToRender = (
      <DonutChart
        style={{
          width: "100%",
          padding: "20px 0px",
          margin: "0px 20px",
        }}
        legendPosition="right"
        allowValueHiding={true}
        disableHoverOnChart={false}
        disableHoverOnLegend={false}
        valueText={`${hoverItem ? hoverItem.value : totalValue}`}
        description={userLoginData.donutChartConfig.descriptionText}
        hiddenItems={hiddenItems}
        onHiddenItemsChanged={setHiddenItems}
        onHover={(item) =>
          setHoverItem(data.find((i) => i.key === item))
        }
        onBlur={() => setHoverItem(undefined)}
        data={data}
      />
    );
  } else {
    contentToRender = (
      <p className="center-text-error">{ERROR_LISTLogin.LOGIN_SUMMARY_EMPTY_DATA}</p>
    );
  }

  return (
    <div className="user-login-summary-container">
      {contentToRender}
    </div>
  );
}

export default UserLoginSummary;